import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "../App.css";
import logo from "../assets/Civic X png3 1-2.png";
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

const navLinks = [
  { label: "Home", link: "#" },
  { label: "How It Works", link: "#how-it-works" },
  { label: "Features", link: "#features" },
  { label: "What You Can Report", link: "#what-you-can-report" },
  { label: "FAQs", link: "#faqs" },
  { label: "Contact Us", link: "#contact" },
];

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Fixed Navbar */}
      <nav
        className="navbar navbar-bg navbar-expand-lg bg-light px-3 position-fixed top-0 w-100 shadow-sm"
        style={{ zIndex: 1050 }}
      >
        <div className="container-fluid">
          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="https://play.google.com/">
            <img src={logo} alt="CivicX" height="30" className="me-2" />
          </a>

          {/* Hamburger toggle - only visible on mobile */}
          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={() => setIsMobileMenuOpen(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop nav */}
          <div className="collapse navbar-collapse justify-content-center d-none d-lg-flex">
            <ul className="navbar-nav mb-2 mb-lg-0 gap-lg-4 text-lg-center">
              {navLinks.map((item) => (
                <li className="nav-item" key={item}>
                  <a className="nav-link" href={item.link}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="d-none d-lg-flex gap-2 ms-4">
              <a href="https://play.google.com/" className="btn btn-link p-0 border-0">
                <img src={googleImg} alt="Google Play" height="40" />
              </a>
              <a href="https://play.google.com/" className="btn btn-link p-0 border-0">
                <img src={appStoreImg} alt="App Store" height="40" />
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Push content down to avoid overlapping the navbar */}
      <div style={{ height: "72px" }}></div>

      {/* Mobile full screen menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay position-fixed top-0 start-0 w-100 h-100 bg-light z-1050">
          <div className="d-flex justify-content-between align-items-start px-4 pt-3">
            <img src={logo} alt="CivicX" height="30" />
            <button
              className="btn btn-link text-dark fs-3"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              &times;
            </button>
          </div>

          <ul className="nav flex-column align-items-start px-4 pt-4 gap-3">
            {navLinks.map((item) => (
              <li className="nav-item" key={item}>
                <a
                  className="nav-link fs-5"
                  href={item.link}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="px-4 pt-4 d-flex gap-3">
            <a href="https://play.google.com/" className="btn btn-link p-0 border-0">
              <img src={googleImg} alt="Google Play" height="40" />
            </a>
            <a href="https://play.google.com/" className="btn btn-link p-0 border-0">
              <img src={appStoreImg} alt="App Store" height="40" />
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
